import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './../store/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.token) {
    store.dispatch('auth/login', to.query.token)
    const query = { ...to.query }
    delete query.token
    return next({ name: to.name, query })
  }
  if (to.name === 'login' && store.getters['auth/isLogged']) {
    return next({ name: 'diagrams' })
  }
  if (to.meta.auth) {
    if (store.getters.auth.isLogged()) {
      next()
    } else {
      next({ name: 'login' })
    }
  } else next()
})

export default router
